module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Italic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Italic-webfont.woff
// module id = 1613
// module chunks = 0